import {EntityService} from '../../../service/EntityService';

export class WrongInvoiceService extends EntityService {

  static entity = 'app/wrong-invoice';

  static getDetail(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/wrong-invoice-detail`).then(res => res.data);
  }

  static downloadXml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/download-xml/${id}`, {responseType: 'blob'}).then(res => res.data);
  }

  static getPdfUrl(id: string): string {
    return `${this.baseURL}/${this.entity}/${id}/downloaf-pdf`;
  }

}
